import React, { useEffect, useState } from "react";
import Card from "../../common/card/Card";
import dash1 from '../../common/assests/dasimg1.png';
import dash2 from '../../common/assests/dasimg2.png';
import dash3 from '../../common/assests/dasimg3.png';
import dash4 from '../../common/assests/dasimg4.png';
import dash5 from '../../common/assests/dasimg5.png';
import { Box, Grid, styled } from '@mui/material';
import './Dashboard.css';
import { dashboardDataApi } from "../../api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { formatCount } from "../../utils/formatCount";

const CustomCard = styled(Box)(({ theme }) => ({
  borderRadius: '24px',
  backgroundColor: '#FFF',
  boxShadow: '3px 2px 20px 0px rgba(0, 0, 0, 0.04)',
  height: '250px',
  flexShrink: 0,
  marginBottom: "20px",
}));

const Dashboard = () => {
  const token = useSelector((state) => state?.user?.user?.token);

  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    usersGrowthPercentage: 0,
    totalVendors: 0,
    vendorsGrowthPercentage: 0,
    totalOrders: 0,
    ordersGrowthPercentage: 0,
    totalProducts: 0,
    productsGrowthPercentage: 0,
    totalEarnings: 0,
    earningsGrowthPercentage: 0,
  });

  const fetchData = async () => {
    try {
      const response = await dashboardDataApi({ token,filter:"" });
      setDashboardData(response);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      toast.error(error?.error || "Failed to fetch dashboard data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const data = [
    { img: dash1, text1: formatCount(dashboardData?.totalUsers), text2: 'Total Users', text3: `${dashboardData?.usersGrowthPercentage || 0}%` },
    { img: dash2, text1: formatCount(dashboardData?.totalVendors), text2: 'Total Vendors', text3: `${dashboardData?.vendorsGrowthPercentage || 0}%` },
    { img: dash3, text1: formatCount(dashboardData?.totalOrders), text2: 'Total Orders', text3: `${dashboardData?.ordersGrowthPercentage || 0}%` },
    { img: dash4, text1: formatCount(dashboardData?.totalProducts), text2: 'Total Products Listed', text3: `${dashboardData?.productsGrowthPercentage || 0}%` },
    { img: dash5, text1: `$${formatCount(dashboardData?.totalEarnings)}`, text2: 'Total Earnings', text3: `${dashboardData?.earningsGrowthPercentage || 0}%` },
  ];

  return (
    <div style={{ maxWidth: '1520px' }}>
      <div className="row g-3 custom-row mb-3">
        {data.map((item, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4 col-xl-3 col-xxl-2">
            <Card data={item} />
          </div>
        ))}
      </div>

      {/* <Box mb={4} mt={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <CustomCard>
              <Box style={{ width: '100%', height: '100%' }}>Graph</Box>
            </CustomCard>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <CustomCard>
              <Box style={{ width: '100%', height: '100%' }}>Graph</Box>
            </CustomCard>
          </Grid>
        </Grid>
      </Box> */}
    </div>
  );
};

export default Dashboard;
